// extracted by mini-css-extract-plugin
module.exports = {"versionTable":"style_versionTable__zpXEc"};